export const PROJECT_PAGES_SOURCE_COMPONENT = 'project-pages';
export const PROJECT_PAGES_SOURCE_CONTEXT = 'project-pages';
